import { Dialog } from "@material-ui/core";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Confirmation = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const navigate = useNavigate();
  const { search } = useLocation();

  const handleConfirmation = async () => {
    setOpen(false);
    navigate({
      pathname: "/dashboard/drought-risk",
      search,
    });
  };

  return (
    <Dialog open={open} maxWidth="md" fullWidth>
      <Stack p={3}>
        <DialogTitle>
          <b>Preparing your shapefile</b>
        </DialogTitle>
        <DialogContent>
          <Stack gap={2}>
            <Typography>
              Your uploaded shapefile is being processed. This may take a few
              minutes depending on file size and server load. Your area will
              initially appear under the selected country and be marked as{" "}
              <b>
                <i>Processing</i>
              </b>
              . Once processing is complete, your user-defined area will be
              available alongside other administrative levels within the country
              and selectable in{" "}
              <b>
                <i>Step 1</i>
              </b>
              .
            </Typography>
            <Typography>
              <i>
                Please note: this user-defined area is visible only to your
                account.
              </i>
            </Typography>
            <Typography>
              You can continue exploring the dashboard while we finish this
              step.
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleConfirmation}>
            OK, got it
          </Button>
        </DialogActions>
      </Stack>
    </Dialog>
  );
};

export default Confirmation;
